import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../../utils/api";
import close_modal from "./../../../assets/ic_close_modal.svg";
import MultiSelectAll from "../../../common/Multiselect/MultiSelectAll";
import Select from "react-select";

export default function LPMFilterModel(props) {

    return (
      <Modal
        isOpen={props.isOpen}
        onRequestClose={props.toggleModal}
        ariaHideApp={false}
      >
        <ModalContent className="lpm-filter-modal">
            <div className="modal-header-sp">
            <span className="modal-title">Filter By</span>
              <img
                  alt="close"
                  id="Close"
                  src={close_modal}
                  className="close modal-close"
                  onClick={props.toggleModal}
              />
            </div>
          
          <div
              className={`modal-body spled-container notes-trail-content custom-scrollbar conv-pl0 conv-pr0`}
          >
              <div className="row conv-mt20">
                  <div className="col-6 width-100">
                      <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={props.followUpDateFrom}
                          onChange={(date) =>props.setFollowUpDateFrom(date)}
                          //minDate={new Date()}
                          placeholderText="Follow Up From"
                      />
                  </div>
                  <div className="col-6 width-100">
                      <ReactDatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={props.followUpDateTo}
                          onChange={(date) =>props.setFollowUpDateTo(date)}
                          placeholderText="Follow Up To"
                      />
                  </div>
              </div>
              <div className="row conv-mt20">
                  <div className="col-6 width-100">
                      <MultiSelectAll
                          toggleAll={props.toggleAllForFilter}
                          toggleSelection={props.toggleSelectionForFilter}
                          checkboxItemsList={props.serviceNameListForFilter}
                          selectedOptions={props.selectedServiceNameListForFilter}
                          placeholderButtonLabel={"Select Services"}
                      />
                  </div>
                  <div className="col-6 width-100">
                      <MultiSelectAll
                          toggleAll={props.toggleAllForPackageFilter}
                          toggleSelection={props.toggleSelectionForPackageFilter}
                          checkboxItemsList={props.packageNameListForFilter}
                          selectedOptions={props.selectedPackageNameListForFilter}
                          placeholderButtonLabel={"Select Package"}
                      />
                  </div>                  
              </div>
              <div className="row conv-mt20">
                  <div className="col-6">
                      <MultiSelectAll
                          toggleAll={props.toggleAllForServiceStatusFilter}
                          toggleSelection={props.toggleSelectionForServiceStatusFilter}
                          checkboxItemsList={props.serviceStatusNameListForFilter}
                          selectedOptions={props.selectedServiceStatusListForFilter}
                          placeholderButtonLabel={"Select Status"}
                      />
                  </div>
                  <div className="col-6">
                      <Select
                        styles={{
                          // Fixes the overlapping problem of the component
                          menu: provided => ({ ...provided, zIndex: 3 })
                        }}
                        placeholder="Moved to SPM"
                        options={props.MovedToSPMStatusOptions}
                        onChange={props.onMovedToPSMStatusChange}
                        value={props.selectedMovedToSPMStatus}
                        className='react-select-container'
                        classNamePrefix="react-select"
                        theme={theme => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary: '#76287C',
                                primary25: '#F4DFF4',
                            },
                            })}
                      ></Select>
                  </div>
              </div>
              <div className="row conv-mt30"style={{marginRight:"-17px",marginLeft:"-17px"}}>
                  <div className="col-12 lpm-modal-bottom-action bottom-action">
                      <button 
                          type="button" 
                          className="lpm-con-btn-filled conv-float-right conv-pr35 conv-pl35"
                          onClick={(e) =>props.onSearchClicked(e)}>
                          Apply
                      </button>
  
                      <button 
                          type="button" 
                          className="lpm-con-btn-bordered-filter conv-float-right conv-mr25 conv-pr25 conv-pl25"
                          onClick={(e) =>props.onClearFilterSearch(e)}>
                          Clear All
                      </button>
                  </div>
              </div>
          </div>
        </ModalContent>
      </Modal>
    );
  }